import React, { SVGProps } from "react";
export default function SupUserAnon019(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M14.8473 8.09018L18 6.27712M14.8473 8.09018V11.8652M14.8473 8.09018L8.48455 4.47417M5.23869 2.62951L8.48455 0.64447L18 6.27712M5.23869 2.62951L2 4.57156M5.23869 2.62951L8.48455 4.47417M8.48455 11.8094V8.09018M8.48455 11.8094L11.6659 9.97768M8.48455 11.8094L5.23869 13.773M18 6.27712V10.0251M8.48455 19.3555L18 13.773V10.0251M8.48455 19.3555V15.5789M8.48455 19.3555L5.23869 17.5639M8.48455 15.5789L14.8473 11.8652M8.48455 15.5789L5.23869 13.773M18 10.0251L14.8473 11.8652M14.8473 11.8652L11.6659 9.97768M8.48455 8.09018L11.6659 9.97768M8.48455 8.09018V4.47417M5.23869 17.5639L2 15.5789V4.57156M5.23869 17.5639V13.773M2 4.57156L5.23869 6.43478M5.23869 13.773V6.43478M8.48455 4.47417L5.23869 6.43478"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
